import React from 'react';
import {ArrowRightOutlined, BankOutlined} from '@ant-design/icons';
import {Button} from 'antd';
import {DiazarFormInput} from './DiazarFormInput';
import {useParameterizedQuery} from 'react-fetching-library';
import {validateCompany} from '../../Actions/Company/CompanyActions';

interface ViewProps {
    setIsValidCompany: React.Dispatch<React.SetStateAction<boolean>>,
    setCompany: React.Dispatch<React.SetStateAction<string>>,
    setValidCompanyErrorMessage: React.Dispatch<React.SetStateAction<string | undefined>>,
    setHasValidCompany: React.Dispatch<React.SetStateAction<boolean>>,
    company: string,
    isLoadingForm: boolean,
    hasValidCompany: boolean,
    isValidCompany: boolean,
    handleIsValidCompanyAction?: (response: { status: number; type: number }) => void,
    validCompanyErrorMessage?: string,
    validCompany: string,
    setValidCompany: React.Dispatch<React.SetStateAction<string>>,
    refSelector?: string
}

export const CompanyInputForm: React.FunctionComponent<ViewProps> = (props) => {
    const {
        setIsValidCompany,
        setCompany,
        company,
        isLoadingForm,
        hasValidCompany,
        isValidCompany,
        setValidCompanyErrorMessage,
        setHasValidCompany,
        handleIsValidCompanyAction,
        validCompanyErrorMessage,
        validCompany,
        setValidCompany,
        refSelector
    } = props;

    const validateCompanyAction = useParameterizedQuery(validateCompany);

    const handleValidateCompany = React.useCallback(() => {
        if (isValidCompany) {
            setValidCompanyErrorMessage(undefined);
            validateCompanyAction.query(company)
                .then(({payload}) => {
                    setHasValidCompany(false);

                    if (payload) {
                        if (payload.error['has-error']) {
                            setValidCompanyErrorMessage(payload.error.error);
                        } else {
                            setValidCompany(company);
                            if (handleIsValidCompanyAction) {
                                handleIsValidCompanyAction(payload.response);
                            }
                        }


                    }
                });
        }
    }, [company, handleIsValidCompanyAction, isValidCompany, setHasValidCompany, setValidCompany, setValidCompanyErrorMessage, validateCompanyAction]);

    React.useEffect(() => {
        const isValidCompany = validCompany.trim() !== '' && company === validCompany;
        setHasValidCompany(isValidCompany);
    }, [company, setHasValidCompany, validCompany]);

    React.useMemo( ()=> {
        if(refSelector !== undefined){
            const refNext  = document.querySelector( `#${refSelector}` );
            const refCompany = document.querySelector( '#login-company' );

            if( refNext !== null && refCompany !== null && refNext instanceof HTMLElement && refCompany instanceof HTMLElement ){
                setTimeout(()=>{
                    if( hasValidCompany ){
                        refNext.focus();
                    }else {
                        refCompany.focus();
                    }
                },300);

            }
        }
    }, [hasValidCompany, refSelector]);


    return (
        <DiazarFormInput id="login-company" label="Empresa" isRequired
                         type="text"
                         placeholder="Empresa"
                         getState={(isValid, value) => {
                             setIsValidCompany(isValid);
                             setCompany(value);
                         }}

                         initialValue={company}
                         isReadOnly={isLoadingForm}
                         prefix={<BankOutlined/>}
                         postElement={(!hasValidCompany) ? (
                             <Button
                                 icon={validateCompanyAction.loading ? undefined : <ArrowRightOutlined/>}
                                 type="primary"
                                 disabled={!isValidCompany || validateCompanyAction.loading}
                                 onClick={handleValidateCompany}
                                 loading={validateCompanyAction.loading}
                             />
                         ) : undefined}
                         onPressEnter={(!hasValidCompany) ? handleValidateCompany : undefined}
                         errorMessage={validCompanyErrorMessage}
        />
    );
};
